import { env } from '@cc-shopping/platform-env';

export const LOGIN_PATH = '/api/nts/v1/login';

type SegmentTrackingAttributesType = {
  anonymousUserId: string;
  deployableName: string;
  deployableVersion: string;
  driverContentId: string;
  driverContentSource: string;
  driverElement: string;
  driverFlowName?: string;
  driverLocation: string;
  driverPageName: string;
  driverPageUrl: string;
  driverPageViewId: string;
  driverSubLocation: string;
  mostRecentTraditionalDeviceId?: string;
};

export type Options = {
  redirectTo: string;
  cancelUrl?: string;
  initialScreen?: 'signin' | 'signup';
} & SegmentTrackingAttributesType;

export class Auth0 {
  private origin: string;

  constructor(origin: string) {
    this.origin = origin;
  }

  public generateAuthLink(options: Options) {
    const loginURL = new URL(LOGIN_PATH, this.origin);

    Object.entries(options).forEach(([key, value]) => {
      loginURL.searchParams.append(key, value);
    });

    return loginURL.toString();
  }

  signIn(options: Omit<Options, 'initialScreen'>) {
    window.location.assign(this.generateAuthLink({ initialScreen: 'signin', ...options }));
  }

  signUp(options: Omit<Options, 'initialScreen'>) {
    window.location.assign(this.generateAuthLink({ initialScreen: 'signup', ...options }));
  }
}

export const auth0 = new Auth0(env.NEXT_PUBLIC_NW_URL);
